<template>
  <div>
    <el-tabs v-model="activeTab" type="border-card" tab-position="left">
        <el-tab-pane label="Basics" name="1">
            <Basic />            
        </el-tab-pane>
        <el-tab-pane label="Production Variations" name="2">
            <div style="width: 100%; text-align: left; display: flex; flex-direction: column;">
                <span type="label">Mention Similar SKU Codes</span>
                <el-select 
                    placeholder="search or scan"
                    remote
                    :remote-method="searchSKUCode"
                    size="small"
                    multiple
                    default-first-option
                    :loading="getLoading"
                    v-model="$store.state.inventoryMaster.props.estore_product_variation" filterable style="text-align: left; width: 80%;">
                    <el-option
                        v-for="(data, index) in $store.getters.getInventoryMasterAutocompleteList"
                        :key="index"
                        :label="data.sku_code"
                        :value="data.id">
                        <span style="float: left" v-html="data.sku_code+' ('+data.article_name+')'"></span>
                        <span style="float: right;" v-if="data.closing_stock !== null || data.closing_stock >0 || data.closing_stock < 0"><b :style="'color: '+(data.closing_stock<0 ? 'red' : 'green')">{{data.closing_stock}} {{data.unit_name}}</b></span>
                    </el-option>
                </el-select>
            </div>
            
        </el-tab-pane>             
        <el-tab-pane label="Price Variations" name="3">
            <PriceVariation />
        </el-tab-pane>
        <el-tab-pane label="Downloadables" name="4">
            <Downloadables />
        </el-tab-pane> 
        <el-tab-pane label="Stylist Names" name="5">
            <div style="width: 100%; text-align: left; display: flex; flex-direction: column;">
                <span type="label">Stylist Names</span>
                <el-select 
                    placeholder="type here..."
                    size="small"
                    multiple
                    v-model="$store.state.inventoryMaster.props.estore_stylist_names" filterable style="text-align: left; width: 80%;">
                    <el-option
                        v-for="(data, index) in $store.getters.getGenericContactList.filter(t => t.display_online === 1)"
                        :key="index"
                        :label="data.full_name"
                        :value="data.id">
                        <span style="float: left" v-html="data.full_name"></span>
                    </el-option>
                </el-select>
            </div>
        </el-tab-pane>
        <el-tab-pane label="Additional Information" name="6">
            <AdditionalInformation />
        </el-tab-pane> 
        
    </el-tabs>
  </div>
</template>

<script>
import Basic from './Basic.vue'
import PriceVariation from './PriceVariation'
import Downloadables from './Downloadables'
import AdditionalInformation from './AdditionalInformation'

export default {
    components: {Basic, Downloadables, PriceVariation, AdditionalInformation},
    data() {
        return {
            activeTab: '1'
        }
    },
    methods: {
        searchSKUCode(query) {
            this.$store.dispatch('fetchInventoryMasterAutocompleteList', 
                {query: query, show_all_item: true, search_column: ['sku_code'], store_id: this.$store.state.inventoryMaster.props.store_id})
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/InventoryMaster/Form/EStore/Index.vue